// Module
var code = `<!-- clProseLinks — prose lead + bulleted list of internal navigation links.
     Data shape: {
       intro?: [ "lead paragraph (markdown-parsed HTML)", ... ],
       items:  [ { title, description, pageId, stage, container?, section?,
                   classMethod?, href }, ... ]
     }
     Follows clCardGrid's pattern: the ROUTE datasets live in the template
     and interpolate from data, so content sanitization (which strips data
     attributes from raw HTML in content strings) never touches them. -->
<div class="block-cl-prose-links {{classStr}}">
  {{#intro}}<p class="block-cl-prose-links__intro">{{.}}</p>{{/intro}}
  <ul class="block-cl-prose-links__list">
    {{#items}}
    <li class="block-cl-prose-links__item">
      <a class="block-cl-prose-links__link"
         data-channel="ROUTE"
         data-is-menu-link="true"
         data-event-prevent-default="true"
         data-page-id="{{pageId}}"
         data-stage="{{stage}}"
         data-container="{{container}}"
         data-section="{{section}}"
         data-class-method="{{classMethod}}"
         href="{{href}}"><b>{{title}}</b></a><span class="block-cl-prose-links__desc"> — {{description}}</span>
    </li>
    {{/items}}
  </ul>
</div>
`;
// Exports
module.exports = code;